import { Component } from "@angular/core";
import { localDataService, localDataServices } from "../../Services/localDataServices";
import { Router, ActivatedRoute } from '@angular/router';
import { JsonPipe, Location } from '@angular/common';
declare var $: any;  //定义jquery
declare var async: any;  //定义jquery
@Component({
    selector: 'identificationView',
    providers: [localDataServices],
    templateUrl: './identification.html',
    styleUrls: ['./identification.css']
})

export class identificationViewComponent {
    tabs: 'tabs1' | 'tabs2' = 'tabs1';
    tabsName = {
        tab1Name: "托书",
        tab2Name: "源文件",
        tab3Name: "托书内容",
    }
    isFillLayout: boolean = false;
    token: string;
    orderNo: string;
    delays: number = 20;
    setDelays: number = 20;
    modalVibisity: boolean = false;
    attrJson: any = {
        shipper: { value: '' }, // 发货人
        ourCompanyNo: { value: '' }, // 同行编号
        placeOfReceipt: { value: '' }, // 收货地
        consignee: { value: '' }, // 收货人
        notifyParty: { value: '' }, // 通知人
        portOfLoading: { value: '' }, // 起运港
        portOfDischarge: { value: '' }, // 卸货港
        portOfDestination: { value: '' }, // 目的港
        numberOfPieces: { value: '' }, // 件数
        grossWeight: { value: '' }, // 毛重
        volume: { value: '' }, // 体积
        packing: { value: '' }, // 包装
        etd: { value: '' }, // 要求ETD
        serviceTerm: { value: '' }, // 运输条款
        paymenTerm: { value: '' }, // 运费条款
        client: { value: '' }, // 委托方
        contacts: { value: '' }, // 联系人
        contactPhone: { value: '' }, // 联系人电话
        goodName: { value: '' }, // 品名
        marks: { value: '' }, // 唛头
        remarks: { value: '' }, // 备注
        /* -------------------------- */
        imgPath: '', // 图片
        originalPath: '' // 源文件
    };
    constructor(
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _localDataService: localDataService,
        private _location: Location
    ) {

    }

    ngOnInit() {

        this._activatedRoute.queryParams.subscribe(params => {
            if (params.tabs) {
                let activeTabs = JSON.parse(decodeURI(params.tabs));
                this.tabsName = { ...this.tabsName, ...activeTabs };
            }
            if (params.delays > 0) {
                this.delays = params.delays;
                this.setDelays = params.delays;
            }
        })


        this._activatedRoute.params.subscribe((params => {
            this.token = params.token;
            this.orderNo = params.orderNo;
            // this.identifyData(params);
            // this.getSomeType();
        }))
    }
    // 获取 单证数据 
    identifyData(params: any = { token: this.token, orderNo: this.orderNo }) {
        this.modalVibisity = true;
        if (this.delays !== this.setDelays) { this.delays = this.setDelays }
        let timer = setInterval(() => {
            if (this.delays <= 0) { return clearInterval(timer) }
            this.delays--;
        }, 1000)

        // this._localDataService.identDetails(params)
        //     .then((res: any) => {
        //         console.log(res)
        //         let { status, data: { attrJson } } = res;
        //         if (status) {
        //             this.attrJson = attrJson;
        //             clearInterval(timer);
        //             this.modalVibisity = false;
        //             // this.drawLoading();
        //         }
        //     })
    }
    // 保存
    updataHander(event, setType) {
        let $btn = $(event.target).button('loading')
        // this._localDataService.saveIdentDetails({ token: this.token, orderNo: this.orderNo, msCoID: this.msCoID, orderStatus: setType, attrJson: this.attrJson })
        //     .then((res: any) => {
        //         let { code, message } = res;
        //         alert((setType ? '发送' : '保存') + message)
        //         $btn.button('reset');
        //     })
    }
    msCoID: any;
    getSomeType() {
        this._localDataService.getThisCompanyHaveSomeType(this.token).then((res: any) => {
            if (res.status) {
                this.msCoID = res.data.filter((item) => item.code === 'W0001')[0]['coBizId'];
            } else {
                console.log(res.message);
            }
        })
    }
    // 图片缩放功能
    degNum: number = 1;
    // 图片放大 
    onBig(event) {
        if (this.degNum <= 2) {
            this.degNum = this.degNum + 0.2
        }
    }
    // 图片缩小
    onSmall(event) {
        if (this.degNum > 0.2) {
            this.degNum = this.degNum - 0.2;
        }
    }
    lineWidth: string = '0px'
    lineHeight: string = '0px'
    lineTop: string = '0px'
    lineLeft: string = '0px'

    // input focus 标记 红色位置
    drawTag(rows) {
        let { width } = this.attrJson;
        let imgwidth = $('.tuoshuimg').find('img').css("width").split("px")[0];
        this.lineWidth = Number(rows.right - rows.left) * Number(imgwidth / width) + 'px';
        this.lineHeight = Number(rows.bottom - rows.top) * Number(imgwidth / width) + 'px';
        this.lineTop = Number(rows.top) * Number(imgwidth / width) + 'px';
        this.lineLeft = Number(rows.left) * Number(imgwidth / width) + 'px';
    }
    // 清除 标记
    clearTag() {
        this.lineWidth = '0px'
        this.lineHeight = '0px'
        this.lineTop = '0px'
        this.lineLeft = '0px'
    }
    // 固定宽度1200  切换
    onLayoutHander() {
        this.isFillLayout = !this.isFillLayout
    }
    // tabs 切换 
    onceSetIframeScore = null;
    onTab(activeTab) {
        this.tabs = activeTab;
        if (activeTab === 'tabs2') {
            $('.iframeScore').height($('.tibcontant').height() - 10)
            if (this.onceSetIframeScore === null) {
                this.onceSetIframeScore = this.attrJson.originalPath + '?' + new Date().getTime();
                $('.iframeScore').attr('src', this.onceSetIframeScore);
            }
        }
    }

    drawLoading() {
        let cvs = <HTMLCanvasElement>document.getElementById('loading-canvans');
        cvs.width = 1200;
        cvs.height = 800;
        let cvsCxt = cvs.getContext('2d');
        cvsCxt.arc(0, 0, 360, 0, 360)
        cvsCxt.stroke();
    }
    setTabsName(activeTabs){
        this.tabsName = { ...this.tabsName, ...activeTabs };
    }
}



// WEBPACK FOOTER //
// /srv/jenkins-test/workspace/dev-doc-web/src/app/component/identificationView/identification.ts